export const MAX_PROFILES = 10;
export const MAX_STEPS_PER_PROFILE = 5;
export const MAX_PROMPTS_PER_PROFILE = 5;
export const MAX_CUSTOM_VARIABLES = 25;
export const MAX_CUSTOM_VARIABLE_VALUE_LENGTH = 500;
